module.exports = __webpack_public_path__ + "static/media/reliquia-virgen-coromoto-antes.2b9e2177.jpg";